import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Header } from "../../../components/header";

import { SentinelForm } from "../components";
import { useSentinel, useUpdateSentinel } from "../hooks";
import { X } from "lucide-react";

type IUpdateSentinel = {
  id: string;
};

export const UpdateSentinel: React.FC = () => {
  const { id } = useParams<IUpdateSentinel>();
  const navigate = useNavigate();

  useEffect(() => {
    if (!id) {
      navigate("/payments");
    }
  }, []);

  const { form, submit, loading } = useUpdateSentinel({
    id: +id!,
    onCompleted: () => {
      toast.success("La sentinelle a été modifiée avec succès");
    },
  });

  const { data } = useSentinel(+id!);

  useEffect(() => {
    if (data?.sentinel?.ok && data?.sentinel?.result) {
      const input = form.getValues();
      const { result } = data?.sentinel;

      Object.keys(result).forEach((key) => {
        if (Object.keys(input).includes(key)) {
          // @ts-ignore
          form.setValue(key, result[key]);
        }
      });
    }
  }, [data]);

  return (
    <>
      <Header
        title="Sentinel"
        subtitle="Mise à jour d'une sentinelle"
        buttons={[
          {
            actionText: "Annuler",
            bgColor: "indigo",
            textColor: "white",
            link: `/sentinels`,
            icon: <X />,
          },
        ]}
      />
      <div className="main-container">
        <SentinelForm loading={loading} submit={submit} form={form} />
      </div>
    </>
  );
};
